(function () {
  'use strict';

  function renderCartCount(itemCount) {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink) return;

    var existingCount = cartLink.querySelector('.custom-header__cart-count');
    if (!itemCount || itemCount <= 0) {
      if (existingCount) existingCount.remove();
      return;
    }

    var displayCount = itemCount > 99 ? '99+' : String(itemCount);
    if (!existingCount) {
      existingCount = document.createElement('span');
      existingCount.className = 'custom-header__cart-count';
      existingCount.setAttribute('aria-hidden', 'true');
      cartLink.appendChild(existingCount);
    }
    existingCount.textContent = displayCount;
  }

  function syncCartCount() {
    if (!window.routes || !window.routes.cart_url) return;
    fetch(window.routes.cart_url + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCartCount(cart && cart.item_count ? cart.item_count : 0);
      })
      .catch(function () {});
  }

  function initHeader(section) {
    if (!section || section.dataset.customHeaderReady === 'true') return;

    var toggle = section.querySelector('[data-header-toggle]');
    var mobileLinks = section.querySelectorAll('.custom-header__mobile-menu a');
    if (!toggle) return;

    var closePanel = function () {
      section.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', function () {
      var isOpen = section.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    mobileLinks.forEach(function (link) {
      link.addEventListener('click', closePanel);
    });

    section.dataset.customHeaderReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-custom-header]').forEach(initHeader);
    syncCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      syncCartCount();
    });
  }
})();

document.addEventListener('DOMContentLoaded', () => {
    const ticker = document.querySelector('.announcement-bar-section .announcement-bar__ticker');

    if (!ticker) return;

    let scrollTimeout;

    window.addEventListener('scroll', () => {
        ticker.style.animationPlayState = 'paused';

        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
            ticker.style.animationPlayState = 'running';
        }, 150);
    }, { passive: true });
});